import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../../components/Button';
import ModuleSection from '../ModuleSection';
import ArticleEditModal from '../ArticleEditModal';
import blogStorage from '../../utils/storage';
import './index.scss';

const DraftBox = () => {
  const navigate = useNavigate();
  const [drafts, setDrafts] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredDrafts, setFilteredDrafts] = useState([]);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editingDraftId, setEditingDraftId] = useState(null);

  useEffect(() => {
    loadDrafts();
  }, []);

  useEffect(() => {
    filterDrafts();
  }, [drafts, searchQuery]);

  const loadDrafts = () => {
    const draftsData = blogStorage.getDrafts();
    setDrafts(draftsData);
  };

  const filterDrafts = () => {
    let filtered = [...drafts];
    
    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter(draft =>
        draft.title.toLowerCase().includes(query) ||
        draft.content.toLowerCase().includes(query)
      );
    }
    
    // 按最后编辑时间排序
    filtered.sort((a, b) => new Date(b.lastEditedAt) - new Date(a.lastEditedAt));
    
    setFilteredDrafts(filtered);
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleEdit = (draft) => {
    setEditingDraftId(draft.id);
    setEditModalOpen(true);
  };

  const handleSaveDraft = (savedDraft) => {
    loadDrafts(); // 重新加载数据
    setEditingDraftId(null);
    setEditModalOpen(false);
  };

  const handleCloseEditModal = () => {
    setEditModalOpen(false);
    setEditingDraftId(null);
  };

  const handleDelete = (draftId) => {
    if (confirm('确定要删除这个草稿吗？')) {
      blogStorage.deleteDraft(draftId);
      loadDrafts();
    }
  };

  const handlePublish = (draftId) => {
    if (confirm('确定要发布这个草稿吗？')) {
      const article = blogStorage.publishDraft(draftId);
      if (article) {
        alert('草稿发布成功');
        loadDrafts();
        // 跳转到内容列表页面
        navigate('/blog/articles');
      }
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString('zh-CN');
  };

  return (
    <div className="draft-box">
      {/* 草稿列表 */}
      <ModuleSection
        title="草稿箱"
        headerExtra={`共 ${filteredDrafts.length} 个草稿`}
        actions={
          <div className="draft-header-actions">
            <div className="search-input-wrapper">
              <span className="search-icon">🔍</span>
              <input
                type="text"
                value={searchQuery}
                onChange={handleSearch}
                placeholder="搜索草稿..."
                className="search-input"
              />
            </div>
          </div>
        }
        variant="list"
        noPadding
      >
        <div className="drafts-list">
        {filteredDrafts.length > 0 ? (
          filteredDrafts.map(draft => (
            <div key={draft.id} className="blog-card">
              <div className="draft-content">
                <h4 className="blog-title">{draft.title}</h4>
                <div className="draft-meta">
                  <span className="edit-time blog-text-primary">
                    最后编辑: {formatDate(draft.lastEditedAt)}
                  </span>
                  <span className="word-count blog-text-secondary">{draft.wordCount} 字</span>
                </div>
                <div className="draft-summary blog-text-secondary">
                  {draft.content.substring(0, 150)}...
                </div>
                {draft.tags.length > 0 && (
                  <div className="draft-tags">
                    {draft.tags.map(tag => (
                      <span key={tag} className="tag">{tag}</span>
                    ))}
                  </div>
                )}
              </div>
              
              <div className="draft-actions">
                <Button 
                  type="primary"
                  onClick={() => handleEdit(draft)}
                >
                  编辑
                </Button>
                <Button 
                  onClick={() => handlePublish(draft.id)}
                >
                  发布
                </Button>
                <Button 
                  type="danger"
                  onClick={() => handleDelete(draft.id)}
                >
                  删除
                </Button>
              </div>
            </div>
          ))
        ) : (
          <div className="empty-state">
            <div className="empty-icon">📄</div>
            <p>暂无草稿</p>
          </div>
        )}
        </div>
      </ModuleSection>

      {/* 编辑模态弹窗 */}
      <ArticleEditModal
        isOpen={editModalOpen}
        onClose={handleCloseEditModal}
        mode="draft"
        draftId={editingDraftId}
        onSave={handleSaveDraft}
      />
    </div>
  );
};

export default DraftBox;
